import { render, staticRenderFns } from "./DescriptionListEdit.vue?vue&type=template&id=02951ee4&"
import script from "./DescriptionListEdit.vue?vue&type=script&lang=js&"
export * from "./DescriptionListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports